// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel

let lastTime = 0;

['ms', 'moz', 'webkit', 'o'].forEach(vendor => {
  if (global.requestAnimationFrame && global.cancelAnimationFrame) {
    return;
  }

  global.requestAnimationFrame = global[`${vendor}RequestAnimationFrame`];
  global.cancelAnimationFrame = global[`${vendor}CancelAnimationFrame`] ||
                                global[`${vendor}CancelRequestAnimationFrame`];
});

if (!global.requestAnimationFrame) {
  global.requestAnimationFrame = function (callback) {
    const currTime = new Date().getTime();
    const timeToCall = Math.max(0, 16 - (currTime - lastTime));
    const id = global.setTimeout(() => {
      callback(currTime + timeToCall);
    }, timeToCall);
    lastTime = currTime + timeToCall;
    return id;
  };
}

if (!global.cancelAnimationFrame) {
  global.cancelAnimationFrame = function (id) {
    clearTimeout(id);
  };
}



// WEBPACK FOOTER //
// ./src/polyfill/requestAnimationFrame.js